export default __webpack_public_path__ + "static/media/angle-left-solid.e6b3ab3d.svg";